import { z } from "zod";

export const notificationMetadataSchema = z
	.object({
		meeting_id: z.string().optional(),
		event_id: z.string().optional(),
		post_id: z.string().optional(),
		comment_id: z.string().optional(),
		community_id: z.string().optional(),
		community_name: z.string().optional(),
		member_id: z.string().optional(),
		member_user_id: z.string().optional(),
	})
	.passthrough();

export type NotificationMetadata = z.infer<typeof notificationMetadataSchema>;
